/**
 * @generated SignedSource<<7ff4b158b86cfa88d44d84e57e671b92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LimitPeriodType = "MINUTES" | "SESSION";
export type ToolUsageType = "AIStudio" | "CustomizerAIImageGenerator" | "CustomizerDesignGenerator" | "CustomizerProductStaging" | "CustomizerVirtualTryOn";
export type UpdateToolUsageRuleInput = {
  allowLoggedUsers: boolean;
  allowNonLoggedUsers: boolean;
  limitEnabled: boolean;
  limitPeriodMinutes?: number | null;
  limitPeriodType?: LimitPeriodType | null;
  maxOperations?: number | null;
  toolType: ToolUsageType;
  toolUsageRuleID: number;
};
export type usageControlsMutationsUpdateMutation$variables = {
  input: UpdateToolUsageRuleInput;
};
export type usageControlsMutationsUpdateMutation$data = {
  readonly updateToolUsageRule: {
    readonly allowLoggedUsers: boolean;
    readonly allowNonLoggedUsers: boolean;
    readonly applyToAllTools: boolean;
    readonly id: string;
    readonly limitEnabled: boolean;
    readonly limitPeriodMinutes: number | null;
    readonly limitPeriodType: LimitPeriodType | null;
    readonly maxOperations: number | null;
    readonly toolTargets: ReadonlyArray<{
      readonly toolType: ToolUsageType | null;
    }>;
    readonly toolUsageRuleID: number;
  } | null;
};
export type usageControlsMutationsUpdateMutation = {
  response: usageControlsMutationsUpdateMutation$data;
  variables: usageControlsMutationsUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToolUsageRule",
    "kind": "LinkedField",
    "name": "updateToolUsageRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toolUsageRuleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applyToAllTools",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowLoggedUsers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowNonLoggedUsers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "limitEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "limitPeriodType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxOperations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "limitPeriodMinutes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ToolUsageRuleToolTarget",
        "kind": "LinkedField",
        "name": "toolTargets",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toolType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usageControlsMutationsUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usageControlsMutationsUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8c13efa1949b449a570fe40497130a2a",
    "id": null,
    "metadata": {},
    "name": "usageControlsMutationsUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation usageControlsMutationsUpdateMutation(\n  $input: UpdateToolUsageRuleInput!\n) {\n  updateToolUsageRule(input: $input) {\n    id\n    toolUsageRuleID\n    applyToAllTools\n    allowLoggedUsers\n    allowNonLoggedUsers\n    limitEnabled\n    limitPeriodType\n    maxOperations\n    limitPeriodMinutes\n    toolTargets {\n      toolType\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "37b839bd49ca13ad3f162072f2ebcc58";

export default node;
